import { render } from "./App.vue?vue&type=template&id=20d2f8f7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=20d2f8f7&lang=scss"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__